// src/hooks/useLiveSensors.js
import { useState, useEffect, useRef } from 'react';

export const useLiveSensors = (deviceSerial) => {
  // وضعیت‌های سنسور
  const [sensors, setSensors] = useState({
    temps: Array(9).fill({ value: '--', setpoint: '--', triggered: false }),
    humidity: Array(9).fill({ value: '--', setpoint: '--', triggered: false }),
    wind: { value: '--', setpoint: '--', triggered: false }
  });

  // وضعیت اتصال: 'connecting' | 'online' | 'offline' | 'suspended'
  const [status, setStatus] = useState('connecting');
  
  const wsRef = useRef(null);
  const retryRef = useRef(0);
  const maxRetries = 5;

  // --- تابع تشخیص هوشمند آدرس سوکت ---
  const getSocketUrl = () => {
    const hostname = window.location.hostname;
    const isLocalhost = hostname === 'localhost' || hostname === '127.0.0.1';
    
    if (isLocalhost) {
        // به جای اتصال مستقیم به پورت 8765، از مسیر امن Nginx استفاده کنید
        // این کار باعث می‌شود درخواست شما از فیلتر Nginx رد شده و به پایتون برسد
        return 'wss://sfarm.tabangohar.com/ws'; 
    } else {
        return `wss://${hostname}/ws`;
    }
  };

  useEffect(() => {
    if (!deviceSerial) return;

    setStatus('connecting');
    retryRef.current = 0;

    // استفاده از آدرس هوشمند
    const wsUrl = getSocketUrl();
    console.log(`🔌 Live Sensors Connecting to: ${wsUrl}`);
    
    const ws = new WebSocket(wsUrl);
    wsRef.current = ws;

    ws.onopen = () => {
      console.log(`✅ Socket Connected: ${deviceSerial}`);
      ws.send(JSON.stringify({ action: 'monitor', serial: deviceSerial }));
      ws.send(JSON.stringify({ action: 'scan', serial: deviceSerial }));
    };

    ws.onmessage = (event) => {
  const data = JSON.parse(event.data);
  setStatus('online');
  retryRef.current = 0;

  setSensors(prev => {
    if (data.type === 'temp') {
      const newTemps = [...prev.temps];
      newTemps[data.index] = { ...newTemps[data.index], ...data }; // ترکیب داده‌های جدید با قبلی
      return { ...prev, temps: newTemps };
    } 
    if (data.type === 'humi') {
      const newHumi = [...prev.humidity];
      newHumi[data.index] = { ...newHumi[data.index], ...data };
      return { ...prev, humidity: newHumi };
    } 
    if (data.type === 'wind') {
      return { ...prev, wind: { ...prev.wind, ...data } };
    }
    return prev;
  });
};

    ws.onerror = () => {
       if (retryRef.current < maxRetries) setStatus('offline');
    };
    
    ws.onclose = () => {
       if (retryRef.current < maxRetries) setStatus('offline');
    };

    const scanInterval = setInterval(() => {
      if (retryRef.current >= maxRetries) {
        setStatus('suspended');
        ws.close();
        clearInterval(scanInterval);
        return;
      }

      if (ws.readyState === WebSocket.OPEN) {
        ws.send(JSON.stringify({ action: 'scan', serial: deviceSerial }));
        retryRef.current += 1;
        
        if (retryRef.current > 1) {
            setStatus('offline');
        }
      }
    }, 10000);

    return () => {
      clearInterval(scanInterval);
      ws.close();
    };
  }, [deviceSerial]);

  const manualRetry = () => {
    retryRef.current = 0;
    setStatus('connecting');
    window.location.reload(); 
  };

  return { sensors, status, manualRetry };
};